// extracted by mini-css-extract-plugin
export default {"root":"FeedItem-module-root-PyY8K","content":"FeedItem-module-content-nQs8h","background":"FeedItem-module-background-JetJf","bottom":"FeedItem-module-bottom-rxMjl"};